import React, { useEffect } from 'react';
import moment from 'moment';
import EventTracker from '../../containers/function/eventTracker';

const Loading = (props) => {
  const { showFullscreen } = props;
  const classNameFullscreen = (showFullscreen) ? 'container-fullscreen' : '';
  let momentStartDate, momentEndDate;
  const eventTracker = new EventTracker();

  /**
   * Effect hook to initialize the component load start time
   */
  useEffect(() => {
    // call the function to record the start time of the component load
    initializeComponentLoadStartDate();

    // cleanup function that runs when the component unmounts
    return () => {
      // call the function to send track page load time
      sendTrackPageLoadTime();
    }
  }, []);

  /**
   * Function to record the start time of the component load
   */
  const initializeComponentLoadStartDate = () => {
    momentStartDate = moment(); // Record the current moment
  }

  /**
   * Function to send the track page load time to Google Analytics
   */
  const sendTrackPageLoadTime = () => {
    try {
      momentEndDate = moment();
      const milliseconds = momentEndDate.diff(momentStartDate, 'milliseconds');
      const seconds = momentEndDate.diff(momentStartDate, 'seconds');

      // call the function to track the load time
      eventTracker.trackPageLoadTime({ milliseconds, seconds });
    } catch (error) {
      console.log('ERROR Loading-sendTrackPageLoadTime', error);
    }
  }

  return (
    <div className={`loadingDatos ${classNameFullscreen}`}>
      <div>
        <div className="loading-animate">
          <h2>
            <i className="fas fa-truck-moving" />
          </h2>
        </div>
        <h3>{props.language ? props.language.load.loading : ''}</h3>
      </div>
    </div>
  )
};

export default Loading;



// WEBPACK FOOTER //
// ./source/client/components/common/loading.jsx